module.exports = __webpack_public_path__ + "front/img/main-img-wap-1.1eabc603.png";